var accordion = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/accordion.jpg';
var jigsaw = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/jigsaw.jpg';
var inseparable = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/inseparable.jpg';
var tippingpoint = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/attached.jpg';
var blueblack = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/blueblack.jpg';
var violetlime = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/violetlime.jpg';
var yellowblack = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/yellowblack.jpg';
var trellis = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/trellis.jpg';
var trellisVar1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/trellisVar1.jpg';
var trellisVar2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-sbu/trellisVar2.jpg';

export const allImagesDesktopOrderPaperSBU = [
    [/*COLUMN 1*/
        [
            {
                name: accordion,
                artistName: "Lorraine Shemesh",
                title: "Accordion",
                year: "2018",
                dimensions: "10 1/2 x 8 1/2 in., marker on vellum",
                link: "papersbu1",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: jigsaw,
                artistName: "Lorraine Shemesh",
                title: "Jigsaw,",
                year: "2014",
                dimensions: "9 1/2 x 7 in., marker on vellum",
                link: "papersbu2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: trellis,
                artistName: "Lorraine Shemesh",
                title: "Trellis",
                year: "2020", 
                dimensions: "6 x 7 in., marker on vellum",
                link: "papersbu8",
                privateCollection: ""
            },
            {
                name: trellisVar1,
                artistName: "Lorraine Shemesh",
                title: "Trellis",
                year: "2020", 
                dimensions: "6 x 7 in., marker on vellum",
                link: "papersbu9",
                privateCollection: ""
            },
            {
                name: trellisVar2,
                artistName: "Lorraine Shemesh",
                title: "Trellis",
                year: "2020", 
                dimensions: "6 x 7 in., marker on vellum",
                link: "papersbu10",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: tippingpoint,
                artistName: "Lorraine Shemesh",
                title: "Tipping Point",
                year: "2018",
                dimensions: "9 x 7 1/2 in., marker on vellum",
                link: "papersbu4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: inseparable,
                artistName: "Lorraine Shemesh",
                title: "Inseparable",
                year: "2016",
                dimensions: "10 1/2 x 7 3/4 in., marker on vellum",
                link: "papersbu3",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: violetlime,
                artistName: "Lorraine Shemesh",
                title: "Lime & Violet",
                year: "2014",
                dimensions: "9 x 8 1/2 in., woven origami paper",
                link: "papersbu6",
                privateCollection: ""
            }
        ],
        [
            {
                name: blueblack,
                artistName: "Lorraine Shemesh",
                title: "Blue & Black",
                year: "2014",
                dimensions: "9 x 9 in., woven construction paper",
                link: "papersbu5",
                privateCollection: ""
            }
        ],
        [
            {
                name: yellowblack,
                artistName: "Lorraine Shemesh",
                title: "Yellow & Black",
                year: "2014",
                dimensions: "9 x 9 1/2 in., woven construction paper",
                link: "papersbu7",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderPaperSBU = [
    [{
        name: accordion,
        artistName: "Lorraine Shemesh",
        title: "Accordion",
        year: "2018",
        dimensions: "10 1/2 x 8 1/2 in., marker on vellum",
        link: "papersbu1",
        privateCollection: "Private Collection"
    },
    {
        name: jigsaw,
        artistName: "Lorraine Shemesh",
        title: "Jigsaw,",
        year: "2014",
        dimensions: "9 1/2 x 7 in., marker on vellum",
        link: "papersbu2",
        privateCollection: "Private Collection"
    },
    {
        name: trellis,
        artistName: "Lorraine Shemesh",
        title: "Trellis",
        year: "2020", 
        dimensions: "6 x 7 in., marker on vellum",
        link: "papersbu8",
        privateCollection: ""
    },
    {
        name: trellisVar1,
        artistName: "Lorraine Shemesh",
        title: "Trellis",
        year: "2020", 
        dimensions: "6 x 7 in., marker on vellum",
        link: "papersbu9",
        privateCollection: ""
    },
    {
        name: trellisVar2,
        artistName: "Lorraine Shemesh",
        title: "Trellis",
        year: "2020", 
        dimensions: "6 x 7 in., marker on vellum",
        link: "papersbu10",
        privateCollection: ""
    },
    {
        name: tippingpoint,
        artistName: "Lorraine Shemesh",
        title: "Tipping Point",
        year: "2018",
        dimensions: "9 x 7 1/2 in., marker on vellum",
        link: "papersbu4",
        privateCollection: "Private Collection"
    },
    {
        name: inseparable,
        artistName: "Lorraine Shemesh",
        title: "Inseparable",
        year: "2016",
        dimensions: "10 1/2 x 7 3/4 in., marker on vellum",
        link: "papersbu3",
        privateCollection: "Private Collection"
    },
    {
        name: violetlime,
        artistName: "Lorraine Shemesh",
        title: "Lime & Violet",
        year: "2014",
        dimensions: "9 x 8 1/2 in., woven origami paper",
        link: "papersbu6",
        privateCollection: ""
    },
    {
        name: yellowblack,
        artistName: "Lorraine Shemesh",
        title: "Yellow & Black",
        year: "2014",
        dimensions: "9 x 9 1/2 in., woven construction paper",
        link: "papersbu7",
        privateCollection: ""
    },
    {
        name: blueblack,
        artistName: "Lorraine Shemesh",
        title: "Blue & Black",
        year: "2014",
        dimensions: "9 x 9 in., woven construction paper",
        link: "papersbu5",
        privateCollection: ""
    }]      
]
